var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneMissed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h20v20h-20z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "#ab0404",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.167.833252-5 4.999998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.167.833252 5 4.999998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.3332 14.0999v2.5c.0009.2321-.0466.4618-.1396.6745-.093.2126-.2293.4035-.4003.5604-.1711.1569-.373.2764-.5928.3507-.2199.0744-.4528.102-.684.0811-2.5643-.2786-5.0275-1.1549-7.19164-2.5583-2.01347-1.2795-3.72055-2.9866-5-5-1.40835-2.17404-2.28479-4.64922-2.55833-7.22505-.02083-.23044.00656-.4627.08042-.68198.07385-.21928.19256-.42078.34855-.59167.156-.17089.34587-.30742.55752-.40091.21166-.09349.44046-.14189.67184-.14211h2.5c.40442-.00398.7965.13924 1.10314.40295s.50693.62993.56353 1.03039c.10552.80005.30121 1.5856.58333 2.34166.11212.29827.13639.62243.06992.93407-.06646.31164-.22086.59769-.44492.82427l-1.05833 1.05833c1.1863 2.08625 2.91371 3.81375 4.99997 5.00005l1.0584-1.0584c.2265-.224.5126-.3784.8242-.4449.3117-.0665.6358-.0422.9341.0699.7561.2821 1.5416.4778 2.3417.5834.4048.0571.7745.261 1.0387.5729.2643.3119.4047.71.3946 1.1187z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneMissed);
export default __webpack_public_path__ + "static/media/phone-missed.cfd83e6bac5b199fde05b824b676b17d.svg";
export { ForwardRef as ReactComponent };